import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {
    GetHidRecordDetails,
    UpdateHidRecord,
} from '../../../../../reduxToolkit/HID/HidApi';
import {useEffect} from "react";
import {CONTROLLER_DATA} from "../Model/Models";
import {toast} from "react-toastify";
import {t} from "i18next";
import {errorMsg} from "../../../../../Apis/functions";
import {clearGetHidRecordDetails} from "../../../../../reduxToolkit/HID/HidSlice";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Custom hook to manage the update controller form, connection, reset, and config
 */
const UpdateControllerApp = ({
                                 controller,
                                 setController,
                                 setEmptyFields,
                                 isValidIp,
                             }) => {
    const dispatch = useDispatch();
    const { id } = useParams();

    // Redux selectors
    const { getHidRecordDetails } = useSelector((state) => state?.HidSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    // Load controller data on mount
    useEffect(() => {
        getData();
        return () => {
            dispatch(clearGetHidRecordDetails()); // Clean up on unmount
        };
    }, []);

    /**
     * Fetch controller details from the API and set local state
     */
    const getData = () => {
        dispatch(GetHidRecordDetails({ id: id })).then(
            ({ payload: { data: { data } } }) => {
                setController(CONTROLLER_DATA.set(data));
            }
        );
    }

    /**
     * Handle update of controller information
     * Validates controller and IP before dispatching update
     */
    const handleUpdate = () => {
        if (!controller.isValid() || !isValidIp) {
            if (!controller.isValid()) setEmptyFields(true);
            return;
        }
        const body = controller.toAddEdit();
        dispatch(UpdateHidRecord(body)).then(
            ({ payload: { data: { code, success } } }) => {
                if (success === true) {
                    toast.success(t('has_been_updated_successfully'));
                    getData(); // Refresh after update
                } else errorMsg(code);
            }
        );
    };

    

    return {
        DEV, // Development flag
        permission, // User permissions
        handleUpdate, // Update controller
        getData, // Refresh controller data
        defaultSioList: getHidRecordDetails?.sios, // Default SIOs for child tables
        defaultFormatList: getHidRecordDetails?.formats, // Default formats for child tables
        dispatch, 
        id
    };
}

export default UpdateControllerApp;
